module.exports = __webpack_public_path__ + "media/img/uploads/atak-mil-product-thumb-02-9938dad98c5488f60bd7ecbebe0d0ba1.png";